import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'

import TeacherCompanyProfile from '../../components/views/teacher/CompanyProfile'

import injectRole from '../../components/HOC/injectRole'

import { TRoles, TRoutes } from '../../shared/const'

/**
 * Das Unternehmensprofil einer betreuten Junior Company (`/companies/:id`).
 * Nur für Lehrkräfte: Die Verwaltung hat ihr eigenes Firmenprofil unter
 * `/company-review/:id`, Schüler:innen ihr eigenes unter `/company`.
 */
function TeacherCompanyPage(props) {
	if (props.role === TRoles.TEACHER) return <TeacherCompanyProfile />
	else return <Redirect to={TRoutes.DASHBOARD} />
}

TeacherCompanyPage.propTypes = {
	role: PropTypes.string.isRequired
}

export default injectRole(TeacherCompanyPage)
